import { render } from "./trashCan.vue?vue&type=template&id=15505d08"
import script from "./trashCan.vue?vue&type=script&lang=js"
export * from "./trashCan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__